import { render, staticRenderFns } from "./choosePeople.vue?vue&type=template&id=369376ec&scoped=true&"
import script from "./choosePeople.vue?vue&type=script&lang=ts&"
export * from "./choosePeople.vue?vue&type=script&lang=ts&"
import style1 from "./choosePeople.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369376ec",
  null
  
)

export default component.exports